import * as actionTypes from './actionTypes'

const initialState = {
  count: 0,
  isIncrementing: false,
  isDecrementing: false,
  isLoginInProgress: false,
  access_token: localStorage.getItem('SARAFAN_ADMIN_ACCESS_TOKEN') || null,
  user: JSON.parse(localStorage.getItem('SARAFAN_ADMIN_USER')),
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INCREMENT_REQUESTED:
      return {
        ...state,
        isIncrementing: true
      }

    case actionTypes.INCREMENT:
      return {
        ...state,
        count: state.count + 1,
        isIncrementing: !state.isIncrementing,
        user: null,
        access_token: null
      }

    case actionTypes.DECREMENT_REQUESTED:
      return {
        ...state,
        isDecrementing: true
      }

    case actionTypes.DECREMENT:
      return {
        ...state,
        count: state.count - 1,
        isDecrementing: !state.isDecrementing
      }

    case actionTypes.LOGIN_REQUESTED:
      console.log('LOGIN_REQUESTED');
      console.log(state);

      return {
        ...state,
        isLoginInProgress: true
      }

    case actionTypes.LOGIN_SUCCEED:
      console.log('LOGIN_SUCCEED');
      console.log(state);

      return {
        ...state,
        isLoginInProgress: false,
        user: action.user,
        access_token: action.access_token
      }

    case actionTypes.LOGIN_FAIL:
      return {
        ...state,
        isLoginInProgress: false,
        user: null,
        access_token: null
      }

    case actionTypes.LOGOUT:
      return {
        ...state,
        isLoginInProgress: false,
        user: null,
        access_token: null
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/auth/reducer.js